import appStore from 'store';
import api from './api';

const store = {

    namespaced: true,

    state: {
        accountInfo: [],
        coins:[]
    },

    mutations: {

        setAccountInfo(state, payload) {
            state.accountInfo = payload;
        },

        setCoins(state,payload) {
            state.coins = payload;
        }
    },

    actions: {

        getWalletAccountList({commit}) {
            api.listWalletAccount().then(response => {
                commit('setAccountInfo', response.data);
            })
        },

        removeWalletAccountConfig({commit}, data) {
            return api.removeWalletAccount(data);
        },

        alterWalletAccount({commit}, data) {
            return api.updateWalletAccount(data);
        },

        insertWalletAccount({commit}, data) {
            return api.createWalletAccount(data);
        },

        getAllSuppCoin({commit}) {
            api.getAllSupportCoin().then(response =>{
                commit('setCoins',response.data);
            })
        }
    }
}

appStore.registerModule('walletAccount', store)